/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { supabase } from "../../supabaseClient";
import { makeStyles } from "@material-ui/core/styles";
import cssClasses from "./FOSRegisteration.module.css";
import { useNavigate } from "react-router-dom";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";

import RightArrow from "../Icons/RightArrow";
// import SearchIcon from "../Icons/SearchIcon";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
//AutoComplete
import Paper from "@material-ui/core/Paper";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
//images
import SearchIcon from "../../Assets/Images/SearchIcon.svg";
import backArrow from "../../Assets/Images/backArrow.svg";
import block from "../../Assets/Images/block.svg";
import logo from "../../Assets/Images/Logo.png";
import uploadFile from "../../Assets/Images/uploadFile.svg";
import greenCheckedIcon from "../../Assets/Images/greenChecked.svg";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import copy from "copy-to-clipboard";
//
import debounce from "lodash.debounce";
import CircularProgress from "@mui/material/CircularProgress";
//react-phone-number-input
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import TermsAndConditionJson from "./TermsAndConditons.json";
//services
import {
  getPAN_cardDetails,
  getAadharCardDetails,
  getAccountDetails,
} from "../../Services/SurepassApi";
import {
  getCpBillingName,
  signUpFos,
  addKYCDocFos,
  checkFOSExists,
  checkCPExists,
  getFOSId,
  handleErrors,
} from "../../Services/LoginService";
import { checkPhoneNumberIsBlackListed } from "../../Services/LeadService";

import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { sendOTPMessage, sendMailTo, sendMessage, sendOTPMessageMail } from "../../Services/SmsService";
import { checkForUniqueDocs } from "../../Services/LoginService";
import { Network } from "@capacitor/network";
import Countdown, { zeroPad } from "react-countdown";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import CryptoJS from 'crypto-js';
const useStyles = makeStyles((theme) => ({
  radioLabel: {
    fontFamily: "Inter-Medium !important",
    fontSize: "1.6rem",
    lineHeight: "2.5rem",
  },
  textStyle: {
    fontSize: "1.6rem ",
    fontFamily: "Inter-Medium",
    lineHeight: "2.4rem ",
    borderBottom: "1px solid #F2F4F7",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    // padding:'0.5rem 1rem',
  },
  customTextField: {
    "& input::placeholder": {
      fontSize: "1.6rem !important",
    },
  },
  autoCompleteInput: {
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  stepper: {
    "& .MuiLinearProgress-root": {
      backgroundColor: "rgba(82, 108, 130, 0.1) !important",
      height: "0.8rem !important",
      borderRadius: "5rem !important",
      width: "100% !important",
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#155EEF !important",
      },
    },
  },
}));

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem !important",
          fontFamily: "Inter-Medium !important",
          lineHeight: "2.4rem !important",
          borderRadius: 20,
          borderColor: "#84CAFF !important",
          paddingRight: "3rem !important",
          "& input[text]": {
            color: "#101828 !important",
          },
          "& input[input:-internal-autofill-selected]": {
            background: "#F2F4F7 !important",
          },
          "& input[value]": {
            background: "#FFFFF !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused": {
            background: "#FFFFFF",
            border: "1px solid #84CAFF !important",
            boxShadow:
              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& label": {
            fontSize: "1.6rem !important",
          },
        },
      },
    },
  },
});
export default function FOSRegisteration() {
  const [personalDetail, setPersonalDetail] = useState({
    name: "",
    email: "",
    password: "",
    phoneNumber: "",
  });
  const [generalDetail, setGeneralDetail] = useState({
    panNumber: "",
    panName: "",
    panObject: {},
    aadharObject: {},
    aadharName: "",
    aadharNumber: "",
  });
  const [bankDetails, setBankDetails] = useState({
    holderName: null,
    accountNumber: null,
    ifscCode: null,
    branchName: null,
  });

  const [isLoadingIfSC, setIsLoadingIfSC] = useState(false);
  const [isLoadingAccount, setIsLoadingAccount] = useState(false);
  const [CPEDetails, setCPEDetails] = useState("");
  const [getCPENAME, setGetCPEName] = useState([]);
  const [helperText, setHelperText] = useState({
    name: "",
    email: "",
    password: "",
    panNumber: "",
    isPhoneNumber: "",
    isPanValid: false,
    aadharNumber: "",
    isAadharValid: false,
    CPEName: "",
    isHolderName: "",
    isAccountNumber: "",
    isIfscCode: "",
    isBranchName: "",
  });
  const [totalSteps, setTotalStep] = useState(7);
  const [activeStep, setActiveStep] = React.useState(1);
  const [personalButtonNext, setPersonalButtonNext] = useState(false);
  const [GeneralInfoNext, setGeneralInfoButtonNext] = useState(false);
  const [selectCPEButtonNext, setSelectCPEButtonNext] = useState(false);
  const [hideBackButton, setHideBackButton] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [state, setState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [emailState, setEmailState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [isInterNational, setIsInterNational] = useState(false);
  const [recievedOtp, setRecievedOtp] = useState(null);

  const [otptimer, setOtpTimer] = useState(false);
  const [recievedEmailOtp, setRecievedEmailOtp] = useState(null);
  const [otptimerEmail, setOtpTimerEmail] = useState(false);
  const [resendButton, setResendButton] = useState(false);
  const [isLoadingPan, setIsLoadingPan] = useState(false);
  const [isLoadingAadhar, setIsLoadingAadhar] = useState(false);
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);
  const [verifiedPhoneNumber, setVerifiedPhoneNumber] = useState(false);
  const [verifiedEmail, setVerifiedEmail] = useState(false);
  const [fosDispalyId, setFosDisplayId] = useState("");
  const [bankButtonNext, setBankButtonNext] = useState(false);
  const [acceptTermsAndConditions, setAcceptTermsAndConditions] =
    useState(false);
  const [progress, setProgress] = useState(0);
  const [counting, setCounting] = useState(10);
  const startDate = React.useRef(Date.now());
  const navigate = useNavigate();
  const classes = useStyles();
  const [emailLabelText, setEmailLabelText] = useState("");
  useEffect(() => {
    // console.log(progress);
    if (activeStep === 6) {
      const timer = setInterval(() => {
        setProgress((prevProgress) =>
          prevProgress >= 100 ? 0 : prevProgress + 10
        );
        setCounting(counting - 1);
        // console.log(progress);
      }, 1000);
      console.log(timer);
      return () => {
        console.log(timer);
        clearInterval(timer);
      };
    }
  }, [activeStep, counting]);
  useEffect(() => {
    if (progress === 100) {
      reDirectToLogin();
    }
  }, [progress]);

  useEffect(() => {
    let validation = validatePersonalDetailsForButton();
    if (validation.flag) {
      setPersonalButtonNext(true);
    } else {
      setPersonalButtonNext(false);
    }
  }, [personalButtonNext, validatePersonalDetailsForButton]);
  useEffect(() => {
    let validation = validateGeneralForButton();
    if (validation.flag) {
      setGeneralInfoButtonNext(true);
    } else {
      setGeneralInfoButtonNext(false);
    }
  }, [GeneralInfoNext, validateGeneralForButton]);
  // useEffect(() => {
  //   let validation = validateBankDetailsForButton();
  //   if (validation.flag) {
  //     setBankButtonNext(true);
  //   } else {
  //     setBankButtonNext(false);
  //   }
  // }, [bankButtonNext, validateBankDetailsForButton]);
  const debouncedBankDetailsCall = debounce((e) => {
    checkBankDetails(bankDetails.accountNumber, bankDetails.ifscCode);
  }, 800);

  useEffect(() => {
    console.log(resendButton);
  }, [resendButton]);

  function checkBankDetails(accountNo, IFSC_Code) {
    setIsLoadingIfSC(true);
    setIsLoadingAccount(true);
    console.log(accountNo, IFSC_Code);
    let postBody = {
      id_number: accountNo,
      ifsc: IFSC_Code,
    };
    getAccountDetails(postBody)
      .then((res) => {
        setIsLoadingIfSC(false);
        setIsLoadingAccount(false);
        console.log(res?.data?.data);
        if (res?.data?.data?.account_exists) {
          setHelperText((pre) => {
            pre.isAccountNumber = "";
            pre.isHolderName = "";
            pre.isIfscCode = "";
            pre.bankDetailsIsVerified = true;
            return { ...pre };
          });
          setBankDetails((pre) => {
            pre.holderName = res.data.data.full_name;
            return { ...pre };
          });
          if (generalDetail.panName.includes(res.data.data.full_name)) {
            setHelperText((pre) => {
              pre.isHolderName = "";
              pre.bankDetailsIsVerified = true;
              return { ...pre };
            });
          } else {
            setHelperText((pre) => {
              pre.isHolderName = "Account holder name and name doesn't match";
              pre.bankDetailsIsVerified = false;
              return { ...pre };
            });
          }
          console.log("if");
        } else {
          console.log("else");
          setHelperText((pre) => {
            pre.isAccountNumber = "Something went wrong";
            pre.isIfscCode = "Something went wrong";
            pre.bankDetailsIsVerified = false;
            return { ...pre };
          });
        }
      })
      .catch((err) => {
        setIsLoadingIfSC(false);
        setIsLoadingAccount(false);
        console.log(err);
        // console.log(err.response.data);

        // errorToast(err.response.data.message_code);
        setHelperText((pre) => {
          pre.isAccountNumber = err?.response?.data?.message_code;
          // pre.isIfscCode = err?.response?.data?.message_code;
          pre.bankDetailsIsVerified = false;
          return { ...pre };
        });
        if (err?.response?.data?.message_code.includes("invalid_ifsc")) {
          setHelperText((pre) => {
            pre.isAccountNumber = "";
            pre.isIfscCode = err?.response?.data?.message_code;
            pre.bankDetailsIsVerified = false;
            return { ...pre };
          });
        }
        //! Error Toast
        //* err.response.data.message_code
      });
  }

  const getCPEDetails = useRef(
    debounce((e) => {
      console.log(e);
      if (e !== "") {
        Network.getStatus().then((resp) => {
          if (resp.connected) {
            getCpBillingName(e)
              .then((data) => {
                console.log(data);
                if (data.length !== 0) {
                  setGetCPEName(data);
                } else {
                  setCPEDetails(null);
                  setGetCPEName([]);
                }
              })
              .catch((err) => {
                handleErrors(err, "getCpBillingName");
              });
          } else {
            offlineToast();
          }
        });
      } else {
        setCPEDetails(null);
        setGetCPEName([]);
      }
    }, 800)
  ).current;
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    if (activeStep === 1) {
      navigate("/Register");
    }
  };
  const PAN_CardCheck = useRef(
    debounce((e) => {
      // console.log(e);
      getPAN_cardDetails(e)
        .then((res) => {
          setIsLoadingPan(false);
          checkForUniqueDocs(e)
            .then((resp) => {
              console.log(resp);
              if (resp.length) {
                setHelperText((pre) => {
                  pre.panNumber = "User already exists";
                  pre.isPanValid = false;
                  return { ...pre };
                });
              } else {
                setHelperText((pre) => {
                  pre.panNumber = "";
                  return { ...pre };
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
          console.log(res.data);
          if (res?.data?.message_code === "success") {
            setHelperText((pre) => {
              pre.isPanValid = true;
              return { ...pre };
            });
            console.log("res.data.data.full_name", res.data.data.full_name);
            setGeneralDetail((pre) => {
              pre.panName = res.data.data.full_name;
              pre.panObject = res.data.data;
              return { ...pre };
            });
            setPersonalDetail((pre) => {
              pre.name = res.data.data.full_name;
              return { ...pre };
            });
          }
        })
        .catch((err) => {
          setIsLoadingPan(false);
          console.log("err", err);
          // console.log(err?.response?.data);
          setHelperText((pre) => {
            pre.panNumber = err?.response?.data?.message;
            pre.isPanValid = false;
            return { ...pre };
          });
        });
    }, 800)
  ).current;
  const AADHAR_CardCheck = useRef(
    debounce((e) => {
      // console.log(e);

      getAadharCardDetails(e)
        .then((res) => {
          setIsLoadingAadhar(false);
          checkForUniqueDocs(e)
            .then((resp) => {
              console.log(resp);
              console.log(resp.length > 0, resp.length);
              if (resp.length) {
                setHelperText((pre) => {
                  pre.aadharNumber = "Aadhar number already exists";
                  pre.isAadharValid = false;
                  return { ...pre };
                });
              } else {
                setHelperText((pre) => {
                  pre.aadharNumber = "";
                  return { ...pre };
                });
              }
            })
            .catch((err) => {
              console.log(err);
              dismissLoader();
              handleErrors(err, "FosRegisteration->aadhar err");
            });
          console.log(res.data);
          if (res?.data?.message_code === "success") {
            // console.log("res.data.data.full_name",res.data.data.full_name);
            setHelperText((pre) => {
              pre.isAadharValid = true;
              return { ...pre };
            });
            setGeneralDetail((pre) => {
              pre.aadharObject = res.data.data;
              return { ...pre };
            });
          } else {
            setHelperText((pre) => {
              pre.isAadharValid = false;
              return { ...pre };
            });
          }
        })
        .catch((err) => {
          setIsLoadingAadhar(false);
          handleErrors(err, "FosRegisteration->aadhar err");
          console.log("err", err);
          // console.log(err?.response?.data);

          setHelperText((pre) => {
            pre.aadharNumber = err?.response?.data?.message;
            pre.isAadharValid = false;
            return { ...pre };
          });

          //! Error Toast
          //* err.response.data.message_code
        });
    }, 800)
  ).current;

  function optChange(value1, event) {
    event.preventDefault();
    setState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }
  // !!Email otp
  function optEmailChange(value1, event) {
    event.preventDefault();
    setEmailState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }
  const inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      // const next = elmnt.target.tabIndex - 2;
      // if (next > -1) {
      //     // elmnt.target.form.elements[next].focus();
      //     if (elmnt.target.nextSibling)
      //         elmnt.target.nextSibling.focus();
      // }
    } else {
      console.log("next");
      // const next = elmnt.target.tabIndex + 1;
      const next = parseInt(elmnt.target.id.split('-')[1]) + 1;
      if (next < 5) {
        // elmnt.target.form.elements[next].focus();
        if (elmnt.target.nextSibling)
          elmnt.target.nextSibling.focus();
      }
    }
  };
  function submitOtp() {
    let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
    console.log(finalValue, "recievedOtp", recievedOtp);
    if (finalValue == recievedOtp) {
      setVerifiedPhoneNumber(true);
      setShowOtp(false);
setOtpTimer(false);
      setHelperText((pre) => {
        pre.isPhoneNumber = "";
        return { ...pre };
      });
    } else {
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }


  // **OTP time out SMS For Verifying phone Number
  function smsTimeOut() {
    if (verifiedPhoneNumber === false) {
      setHelperText((pre) => {
        pre.isPhoneNumber = "Otp has expired.Please resend otp";
        return { ...pre };
      });
      setVerifiedPhoneNumber(false);
      
      setVerifiedPhoneNumber(false);
      setShowOtp(true);
      setResendButton(true);
      setOtpTimer(true);
      // setShowEmailOtp(false);
        setState((pre) => {
      pre.otp1 = "";
      pre.otp2 = "";
      pre.otp3 = "";
      pre.otp4 = "";
      return { ...pre };
    });
    setRecievedOtp(null);
  }
}
  // **Send Otp
//   function smsApiCall() {
//     setResendButton(false);
//     // const myTimeout = setTimeout(() => {
//     //   setResendButton(true);
//     // }, 180000);
//     setState((pre) => {
//       pre.otp1 = "";
//       pre.otp2 = "";
//       pre.otp3 = "";
//       pre.otp4 = "";
//       return { ...pre };
//     });
//     setShowOtp(true);
//     let body = {
//       number: personalDetail.phoneNumber,
//       isInterNational: isInterNational,
//     };
//     console.log(body);

//     sendOTPMessage(body)
//       .then((resp) => {
//         if (resp.data.success) {
//           var bytes = CryptoJS.AES.decrypt(resp.data.otp, 'hts secret key');
//           var originalText = bytes.toString(CryptoJS.enc.Utf8);
//           // console.log("FOS Registration OTP", parseInt(originalText));
//           setRecievedOtp(parseInt(originalText));
//           // 900000 ;15 min
//           const myTimeout = setTimeout(smsTimeOut, 900000);
//         } else {
// if (resp.data.otp) {
//           let bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
//           let originalText = bytes.toString(CryptoJS.enc.Utf8);
//           setRecievedOtp(parseInt(originalText));
//           // console.log("Add Lead OTP", parseInt(originalText));
//           } else {
//             // if (resp?.data?.error?.ErrorMessage) {
//             //   errorTost(resp?.data?.error?.ErrorMessage);
// if (resp?.data?.error?.message) {
//               errorTost(resp?.data?.error?.message);
//           } else {
//             errorTost("Something went wrong");
//           }
//         }
// }
//       })
//       .catch((err) => {
//         console.log(err);
//         console.log(err.message);
//       });
//   }
    function smsApiCall() {
  setResendButton(false);

  setState((pre) => {
    pre.otp1 = "";
    pre.otp2 = "";
    pre.otp3 = "";
    pre.otp4 = "";
    return { ...pre };
  });
  setShowOtp(true);

  let body = {
    number: personalDetail.phoneNumber,
    isInterNational: isInterNational,
    email: personalDetail.email ?? null
  };
  // console.log(body);

  sendOTPMessage(body)
    .then((resp) => {
      // Check if the response is successful
      if (resp.data) {
        const encryptedOtp = resp.data.otp;
        // console.log("Encrypted OTP received:", encryptedOtp); // Log the received encrypted OTP

        // Step 1: Decode Base64 (OTP is Base64-encoded)
        let decodedOtp;
        try {
          decodedOtp = atob(encryptedOtp); // Decode base64
          // console.log("Decoded OTP (Base64 to string):", decodedOtp);
        } catch (error) {
          console.error("Base64 decoding failed:", error);
          errorTost("Base64 decoding failed. Please try again.");
          return;
        }

        // Step 2: Decrypt with the same key
        try {
          // AES decryption
          var bytes = CryptoJS.AES.decrypt(decodedOtp, "hts secret key");
          var originalText = bytes.toString(CryptoJS.enc.Utf8);

          // Check if decryption is successful
          if (!originalText) {
            console.error("Decryption failed! Key or ciphertext mismatch.");
            errorTost("OTP decryption failed. Please try again.");
            return;
          }

          // Step 3: Ensure OTP is a valid number
          const otp = parseInt(originalText);
          if (isNaN(otp)) {
            console.error("Invalid OTP received:", originalText);
            errorTost("Invalid OTP. Please try again.");
            return;
          }

          // Log and set the OTP
          console.log("FOS Registration Mobile OTP:", otp);
          setRecievedOtp(otp);

          // Step 4: Set a 15-minute timeout to prevent resending OTP
          const myTimeout = setTimeout(smsTimeOut, 900000);

        } catch (decryptionError) {
          console.error("Decryption failed:", decryptionError);
          errorTost("OTP decryption failed. Please try again.");
        }

      } else {
        // Handle failure cases
        if (resp.data.otp) {
          const encryptedOtp = resp.data.otp;
          // console.log("Encrypted OTP received (else case):", encryptedOtp);

          // AES decryption logic (same as above)
          try {
            let bytes = CryptoJS.AES.decrypt(encryptedOtp, "hts secret key");
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            // console.log("Decrypted OTP (else case):", originalText);

            const otp = parseInt(originalText);
            if (isNaN(otp)) {
              console.error("Invalid OTP received:", originalText);
              errorTost("Invalid OTP. Please try again.");
              return;
            }

            setRecievedOtp(otp);
            console.log("FOS Registration Mobile OTP:", otp);

          } catch (decryptionError) {
            console.error("Decryption failed:", decryptionError);
            errorTost("OTP decryption failed. Please try again.");
          }

        } else {
          if (resp?.data?.error?.message) {
            errorTost(resp?.data?.error?.message);
          } else {
            errorTost("Something went wrong.");
          }
        }
      }
    })
    .catch((err) => {
      console.error(err);
      errorTost("An error occurred while sending OTP.");
    });
}



  function validationPersonalDetails() {
    var form = true;
    if (personalDetail.name === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.name = "Please Enter Name";
        return { ...preValue };
      });
    }
    if (personalDetail.email === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.email = "Please Enter Email";
        return { ...preValue };
      });
    } else {
      if (verifiedEmail === false) {
        errorTost("Please verify email");
      }
    }

    if (personalDetail.password === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.password = "Please Enter Password";
        return { ...preValue };
      });
    }
    if (personalDetail.phoneNumber === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPhoneNumber = "Please Enter Phone Number";
        return { ...preValue };
      });
    } else {
      if (verifiedPhoneNumber === false) {
        errorTost("Please verify phone number");
      }
    }

    return {
      flag: form,
    };
  }
  function validatePersonalDetails() {
    let flag = validationPersonalDetails();
    if (
      flag.flag &&
      helperText.name === "" &&
      helperText.email === "" &&
      helperText.password === "" &&
      helperText.isPhoneNumber === "" &&
      verifiedPhoneNumber && verifiedEmail
    ) {
      handleNext();
    }
  }
  function validatePersonalDetailsForButton() {
    var form = true;
    if (helperText.name !== "" || personalDetail.name === "") {
      form = false;
    }
    if (helperText.email !== "" || personalDetail.email === "") {
      form = false;
    }
    if (helperText.password !== "" || personalDetail.password === "") {
      form = false;
    }
    if (helperText.isPhoneNumber !== "" || personalDetail.phoneNumber === "") {
      form = false;
    }
    if (verifiedPhoneNumber === false) {
      form = false;
    }
    return {
      flag: form,
    };
  }
  function validationGeneralDetails() {
    var form = true;
    if (generalDetail.panNumber === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.panNumber = "PAN Card Number";
        return { ...preValue };
      });
    }
    if (generalDetail.aadharNumber === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.aadharNumber = " Aadhar Card Number";
        return { ...preValue };
      });
    }
    return {
      flag: form,
    };
  }
  function validateGeneralDetails() {
    let flag = validationGeneralDetails();
    if (
      flag.flag &&
      helperText.panNumber === "" &&
      helperText.aadharNumber === "" &&
      helperText.isAadharValid === true &&
      helperText.isPanValid === true
    ) {
      handleNext();
    }
  }
  function validateGeneralForButton() {
    var form = true;
    if (generalDetail.panNumber === "" || helperText.isPanValid === false) {
      form = false;
    }
    if (
      generalDetail.aadharNumber === "" ||
      helperText.isAadharValid === false
    ) {
      form = false;
    }
    return {
      flag: form,
    };
  }
  // function validateBankDetailsForButton() {
  //   var form = true;
  //   // if (bankDetails.holderName === "" || helperText.isHolderName !== "") {
  //   //   form = false;
  //   // }
  //   if (bankDetails.accountNumber === "" || helperText.isAccountNumber !== "") {
  //     form = false;
  //   }
  //   if (bankDetails.ifscCode === "" || helperText.isIfscCode !== "") {
  //     form = false;
  //   }
  //   if (bankDetails.branchName === "") {
  //     form = false;
  //   }
  //   return {
  //     flag: form,
  //   };
  // }
  // function smsTimeOut() {
  //   if (verifiedPhoneNumber === false) {
  //     setHelperText((pre) => {
  //       pre.email = "Otp has expired.Please resend otp";
  //       return { ...pre };
  //     });
  //     setVerifiedPhoneNumber(false);
  //   }
  //   showOtp(true);
  //   setOtpTimer(true);
  //   setState((pre) => {
  //     pre.otp1 = "";
  //     pre.otp2 = "";
  //     pre.otp3 = "";
  //     pre.otp4 = "";
  //     return { ...pre };
  //   });
  //   recievedOtp(null);
  // }
    // **OTP time out SMS For Verifying phone Number
    function smsTimeOutForEmailVerify() {
      if (verifiedEmail === false) {
        setHelperText((pre) => {
          pre.email = "Otp has expired.Please resend otp";
          return { ...pre };
        });
setEmailLabelText('Resend Otp');
        setOtpTimerEmail(false);
        setVerifiedEmail(false);
      }
     setShowEmailOtp(true);
      setOtpTimerEmail(true);
      setEmailState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      setRecievedEmailOtp(null);
    }
  function sendOtpToVerifyEmail(){
    setShowEmailOtp(true);
    setOtpTimerEmail(true);
    setEmailLabelText('');
    let body = {
      email: personalDetail.email
    };
    sendOTPMessageMail(body).then((resp) => {
      if (resp.data.success) {
        var bytes = CryptoJS.AES.decrypt(resp.data.otp, 'hts secret key');
        var originalText = bytes.toString(CryptoJS.enc.Utf8);
        console.log("FOS Email Registration OTP", parseInt(originalText));
         setRecievedEmailOtp(parseInt(originalText));
        // 900000 ;15 min
        const myTimeout = setTimeout(smsTimeOutForEmailVerify, 900000);
      } else {
        if (resp?.data?.error?.ErrorMessage) {
          errorTost(resp?.data?.error?.ErrorMessage);
        } else {
          errorTost("Something went wrong");
        }
      }
    });
  }
    // !!For Email
    function submitEmailOtp() {
      let finalValue = emailState.otp1 + emailState.otp2 + emailState.otp3 + emailState.otp4;
      console.log(finalValue, "recievedEmailOtp", recievedEmailOtp);
      if (finalValue == recievedEmailOtp) {
        setVerifiedEmail(true);
        setShowEmailOtp(false);
        setOtpTimerEmail(false);
        setEmailLabelText('');
      } else {
        setEmailState((pre) => {
          pre.otp1 = "";
          pre.otp2 = "";
          pre.otp3 = "";
          pre.otp4 = "";
          return { ...pre };
        });
        errorTost("OTP does not match.Please enter valid otp");
      }
    }
  const checkEmailExists = debounce((e) => {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        checkFOSExists(e)
          .then((resp) => {
            setIsLoadingEmail(false);
            if (resp.length === 0) {
              checkCPExists(e)
                .then((emailExists) => {
                  if (emailExists.length === 0) {
                    setHelperText((pre) => {
                      pre.email = "";
                      return { ...pre };
                    });
                    setEmailLabelText('Send Otp');
                    
                  } else {
                    setEmailLabelText('');
                    setHelperText((pre) => {
                      pre.email = "Email already exists";
                      return { ...pre };
                    });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              setHelperText((pre) => {
                pre.email = "Email already exists";
                return { ...pre };
              });
            }
          })
          .catch((err) => {
            setIsLoadingEmail(false);
            handleErrors(err, "checkEmailExist");
          });
      } else {
        offlineToast();
      }
    });
  }, 800);
  const IsNumberBlackListed = debounce((e) => {
    console.log(e);
    checkPhoneNumberIsBlackListed(e)
      .then((resp) => {
        console.log(resp);
        setVerifiedPhoneNumber(false);
        if (resp.length > 0) {
          setHelperText((pre) => {
            pre.isPhoneNumber = "This number is already in use!";
            // pre.isPhoneNumber = "This number has been blacklisted";
            return { ...pre };
          });
        } else {
          setHelperText((pre) => {
            pre.isPhoneNumber = "";
            return { ...pre };
          });
          // setVerifiedPhoneNumber(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, 800);
  function sendMail(email, subject, message) {
    let body = {
      to: [email],
      subject: subject,
      message: message,
    };
    sendMailTo(body)
      .then((resp) => {
        console.log(resp);
        console.log(resp.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function save() {
    console.log(bankDetails);
    if (CPEDetails === null) {
      helperText.CPEName = "Please Select CPE name";
    } else {
      helperText.CPEName = "";
    }
    if (helperText.CPEName === "") {
      Network.getStatus().then((status) => {
        if (status.connected) {
          presentLoader();
          signUpFos(personalDetail, bankDetails, CPEDetails.value)
            .then(async (user) => {
              console.log(user);
              console.log({ generalDetail });
              await supabase
                .from("FOS")
                .update({ BankAccountNumberText: bankDetails.accountNumber != null ? String(bankDetails.accountNumber) : null })
                .eq("fosId", user.id);
              addKYCDocFos(user.id, generalDetail)
                .then((data) => {
                  console.log(data);
                  getFOSId(personalDetail.email)
                    .then((resp) => {
                      setFosDisplayId("FOSID" + resp[0].fosDisplayId);
                      let message = `<h4>Hello ${personalDetail.name}</h4></br>
                            <p>You have successfully registered with us and here are your login credentials.</p>
                              <p>User ID: <b>${"FOSID" + resp[0].fosDisplayId}</b></p></br>
                            <p>Password: <b>${personalDetail.password}</b></p>
                            <p>Regards,</p>
                            <p>Vilas Javdekar Developers</p>`;
                      sendMail(personalDetail.email, "Registered Successfully", message);
                      // **message
                      let messageBody = {
                        number: personalDetail?.phoneNumber,
                        // number: "+" + personalDetail?.phoneNumber,
                        "message": `Hello ${personalDetail.name}\nYou have successfully registered with us and here are your login credentials.\nUser ID : FOSID${resp[0].fosDisplayId}\nPassword : ${personalDetail.password}\npartners.vjerp.com\nRegards,\nVilas Javdekar Developers`,
//  ! below format gives template error
//                         message: `Hello ${personalDetail.name}

// You have successfully registered with us and here are your login credentials.
                                                           
// User ID : FOSID${resp[0].fosDisplayId}
// Password : ${personalDetail.password}
                                                   
// partners.vjerp.com
                                                   
// Regards,
// Vilas Javdekar Developers`,
                        // message: `Hello ${personalDetail.name},You have successfully registered with us and here are your login credentials.Your User ID:${
                        //   "FOSID" +
                        //   resp[0].fosDisplayId.replace(
                        //     resp[0].fosDisplayId.substring(8, 12),
                        //     "-" + resp[0].fosDisplayId.substring(8, 12)
                        //   )
                        // }.Password:${personalDetail.password}.Regards, Vilas Javdekar Developers`,
                        is_international_number: personalDetail?.phoneNumber.toString().substring(1, 3) !== "91" ? true : false,
                      };
                      sendMessage(messageBody)
                        .then((resp) => {
                          if (resp.data.success) {
                            return true;
                          } else {
                            if (resp?.data?.error) {
                              return false;
                            }
                          }
                        })
                        .catch((err) => {
                          console.log(err.message);
                          return false;
                        });
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                  dismissLoader();
                  handleNext();
                  setHideBackButton(true);

                  // setTimeout(reDirectToLogin, 1000);
                  // setInterval(getTimeLeft,1000,MyTimer);
                  clearTimeout(reDirectToLogin);
                })
                .catch((err) => {
                  dismissLoader();
                  handleErrors(err, "signUpFos->addKyc");
                });
            })
            .catch((err) => {
              dismissLoader();
              handleErrors(err, "signUpFos");
            });
        } else {
          offlineToast();
        }
      });
    }
  }
  function reDirectToLogin() {
    navigate("/Login");
  }
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return console.log("done");
    } else {
      // setResendButton(false);
      // Render a countdown
      // {zeroPad(hours)}
      return (
        <span>
          {" "}
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    }
  };
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperContent}>
        <img className={cssClasses.block} src={logo} alt={"img"}></img>
        {hideBackButton === false && (
          <img
            className={cssClasses.backArrow}
            src={backArrow}
            onClick={handleBack}
            alt={"backArrow"}
            tabIndex="0"
          />
        )}
        <div className={cssClasses.wrapperStepper}>
          <MobileStepper
            variant="progress"
            className={classes.stepper}
            steps={totalSteps}
            position="static"
            activeStep={activeStep}
            sx={{
              maxWidth: "100%",
              // maxWidth:600,
              flexGrow: 1,
              margin: "0 auto",
              background: "#F5F5F5 !important",
            }}
          />
        </div>
        {totalSteps - activeStep - 1 !== 0 ? (
          <div className={cssClasses.label}>
            {totalSteps - activeStep - 1} Steps to your account creation
          </div>
        ) : (
          <div className={cssClasses.label}>Account Created</div>
        )}
        {activeStep === 1 && (
          <div className={cssClasses.wrapperContactDeatils}>
            <div className={cssClasses.detailText}>Terms and Conditions</div>
            <div className={cssClasses.wrapperInnerContent}>
              <div>
                <div className={cssClasses.welcomeMessage}>
                  {TermsAndConditionJson.welcomeMessage}
                </div>
                {TermsAndConditionJson.agreementArray.map((each, index) => {
                  return (
                    <div className={cssClasses.wrapperTermsAndConditionsIndex}>
                      <div className={cssClasses.termsAndConditionsIndex}>
                        {index + 1}. {each.title}
                      </div>
                      <div className={cssClasses.welcomeMessage}>
                        {each.message}
                      </div>
                      <div className={cssClasses.welcomeMessage}>
                        {each.note}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }} />
                  }
                  checked={acceptTermsAndConditions}
                  label={
                    <div className={classes.radioLabel}>
                      I agree with the Terms and Conditions
                    </div>
                  }
                  onChange={(e) => {
                    console.log(e.target.checked);
                    setAcceptTermsAndConditions(e.target.checked);
                  }}
                />
              </FormGroup>
            </div>
            <div>
              {acceptTermsAndConditions ? (
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Accept"}
                  clicked={() => {
                    handleNext();
                  }}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              ) : (
                <Button
                  style={{
                    color: "#155EEF",
                    backgroundColor: "#ffffff",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Accept"}
                  clicked={() => { }}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              )}
            </div>
          </div>
        )}
        {activeStep === 2 && (
          <div className={cssClasses.wrapperGeneralDetails}>
            <div className={cssClasses.detailText}>General Details</div>
            <div className={cssClasses.wrapperInnerContent}>
              <div style={{ textTransform: "uppercase" }}>
                <CustomInput
                  value={generalDetail.panNumber}
                  label={"PAN Number"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    newValue = newValue.trim();
                    console.log(newValue);
                    var regex = /([A-Z*\sa-z]){5}([0-9]){4}([A-Z*\sa-z]){1}$/;
                    if (!regex.test(newValue)) {
                      helperText.isPanValid = false;
                      helperText.panNumber = "Please enter Valid PAN number.";
                    } else {
                      console.log(newValue);
                      helperText.panNumber = " verifying...";
                      if (newValue.length === 10) {
                        setIsLoadingPan(true);
                        PAN_CardCheck(newValue.toUpperCase());
                      }
                    }
                    if (newValue.length <= 10) {
                      setGeneralDetail((pre) => {
                        pre.panNumber = newValue;
                        return Object.assign({}, pre);
                      });
                    }
                  }}
                  placeholder="Enter PAN Number"
                  inputType="label"
                  helperText={helperText.panNumber}
                  isLoading={isLoadingPan}
                  greenTick={helperText.isPanValid}
                />
              </div>
              <div>
                <CustomInput
                  value={generalDetail.aadharNumber}
                  label={"AADHAR Number"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    newValue = newValue.trim();
                    var numbers = /^[0-9]*$/;
                    if (newValue.match(numbers) || newValue === "") {
                      if (newValue.length <= 12) {
                        setGeneralDetail((pre) => {
                          pre.aadharNumber = newValue;
                          return Object.assign({}, pre);
                        });
                      }
                      if (newValue.length === 12) {
                        helperText.aadharNumber = "verifying...";
                        setIsLoadingAadhar(true);
                        AADHAR_CardCheck(newValue);
                      } else {
                        helperText.isAadharValid = false;
                        helperText.aadharNumber =
                          "Please Enter valid Aadhar number.";
                      }
                    }
                  }}
                  placeholder="Enter Aadhar Number"
                  inputType="label"
                  helperText={helperText.aadharNumber}
                  isLoading={isLoadingAadhar}
                  greenTick={helperText.isAadharValid}
                />
              </div>
            </div>
            <div>
              {GeneralInfoNext ? (
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={validateGeneralDetails}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              ) : (
                <Button
                  style={{
                    color: "#155EEF",
                    backgroundColor: "#ffffff",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={validateGeneralDetails}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              )}
            </div>
          </div>
        )}
        {activeStep === 3 && (
          <div className={cssClasses.wrapperGeneralDetails}>
            <div className={cssClasses.detailText}>Personal Details</div>
            <div>
              <CustomInput
                value={personalDetail.name}
                label={"Name"}
                mandatory={true}
                handleChange={(newValue) => {
                  newValue = newValue.trimStart();
                  var alphabet = /^[A-Z*\sa-z]*$/;
                  if (newValue.match(alphabet) || newValue === "") {
                    if (newValue.length <= 40) {
                      setPersonalDetail((pre) => {
                        pre.name = newValue;
                        return Object.assign({}, pre);
                      });
                    }
                  }
                  if (newValue !== "") {
                    setHelperText((pre) => {
                      pre.name = "";
                      return { ...pre };
                    });
                  } else {
                    helperText.name = "Please Enter Name";
                  }
                }}
                placeholder="Enter Name"
                inputType="label"
                helperText={helperText.name}
                disabled={true}
              />
            </div>
            <div>
              <CustomInput
                value={personalDetail.email}
                 label={"Email"}
                mandatory={true}
                inputType={"label"}
                position={"end"}
                greenTick={verifiedEmail}
                labelText={emailLabelText}
                disabled={showEmailOtp || verifiedEmail}
                clicked={(e) => {
                  console.log(e);
                  if (e === 'Send Otp') {
                  sendOtpToVerifyEmail(e);
                  } else if (e === 'Resend Otp') {
                    sendOtpToVerifyEmail(e);
                  }
                }}
                handleChange={(newValue) => {
                  newValue = newValue.trimStart();
                  const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!newValue.trim()) {
                    setEmailLabelText('');
                    helperText.email = "Please Enter Email Id";
                  } else if (!newValue.match(emailIDCond)) {
                    setEmailLabelText('');
                    helperText.email = "Please Enter Email in Proper Format";
                  } else {
                    setIsLoadingEmail(true);
                    setEmailLabelText('');
                    helperText.email = "verifying...";
                    checkEmailExists(newValue);
                  }
                  if (newValue.length <= 100) {
                    setPersonalDetail((pre) => {
                      pre.email = newValue;
                      return Object.assign({}, pre);
                    });
                  }
                }}
                placeholder="Enter contact person Email"
               
                helperText={helperText.email}
                // isLoading={isLoadingEmail}
              />
              {otptimerEmail && (

                <div className={cssClasses.resendOtp}>
                    {" "}
                    Resend Otp in{" "}
                    <CountdownTimer startFrom={180} onComplete={() => { setEmailLabelText('Resend Otp'); setOtpTimerEmail(false); }}
                      timeFormatter={(time) => {
                        return (<span>{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}</span>)
                      }}
                    />
                  </div>
              )}
               {showEmailOtp && (
                <div className={cssClasses.otpContainer}>
                  <input
                    className={cssClasses.otpInput}
                    name="otp1"
                    type="text"
                    autoComplete="off"
                    value={emailState.otp1}
                    // onKeyPress={keyPressed}
                    onChange={(e) => optEmailChange("otp1", e)}
                    tabIndex="1"
                    maxLength="1"
                    onKeyUp={(e) => inputfocus(e)}
                    id='opt-0'
                  />
                  <input
                    name="otp2"
                    type="text"
                    autoComplete="off"
                    className={cssClasses.otpInput}
                    value={emailState.otp2}
                    onChange={(e) => optEmailChange("otp2", e)}
                    tabIndex="2"
                    maxLength="1"
                    onKeyUp={(e) => inputfocus(e)}
                    id='opt-1'
                  />
                  <input
                    name="otp3"
                    type="text"
                    autoComplete="off"
                    className={cssClasses.otpInput}
                    value={emailState.otp3}
                    onChange={(e) => optEmailChange("otp3", e)}
                    tabIndex="3"
                    maxLength="1"
                    onKeyUp={(e) => inputfocus(e)}
                    id='opt-2'
                  />
                  <input
                    name="otp4"
                    type="text"
                    autoComplete="off"
                    className={cssClasses.otpInput}
                    value={emailState.otp4}
                    onChange={(e) => optEmailChange("otp4", e)}
                    tabIndex="4"
                    maxLength="1"
                    onKeyUp={(e) => inputfocus(e)}
                    id='opt-3'
                  />

                  <div>
                    <Button
                      tabIndex={5}
                      style={{
                        color: "#ffffff",
                        backgroundColor: "#155EEF",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                      }}
                      btnName={"Submit OTP"}
                      clicked={submitEmailOtp}
                    />
                  </div>
                </div>
              )}
            </div>
            <div>
              <CustomInput
                value={personalDetail.password}
                label={"Password"}
                mandatory={true}
                handleChange={(newValue) => {
                  newValue = newValue.trim();
                  if (newValue.search(/[A-Z]/) < 0) {
                    helperText.password =
                      "Password should contain atleast 1 Uppercase.";
                  } else if (newValue.search(/[a-z]/) < 0) {
                    helperText.password =
                      "Password should contain atleast 1 LowerCase.";
                  } else if (newValue.search(/[0-9]/) < 0) {
                    helperText.password =
                      "Password should contain atleast 1 number.";
                  } else if (newValue.length < 6) {
                    helperText.password =
                      "Password should contain atleast 6 Characters.";
                  } else {
                    helperText.password = "";
                  }
                  setPersonalDetail((pre) => {
                    pre.password = newValue;
                    return Object.assign({}, pre);
                  });
                }}
                placeholder="Enter contact person Password"
                inputType="password"
                helperText={helperText.password}
              />
            </div>
            <div style={{ position: "relative" }}>
              <div className={cssClasses.blockLabel} >
                Phone Number <span style={{ color: "red" }}> *</span>


              </div>
              <PhoneInput
                defaultCountry="IN"
                value={personalDetail.phoneNumber}
                disabled={showOtp || verifiedPhoneNumber || resendButton}
                placeholder="Enter phone number"
                onChange={(phone) => {
                  console.log(phone);
                  if (phone?.length > 0 && phone !== undefined) {
                    phone = phone.trim();
                  }
                  setPersonalDetail((pre) => {
                    pre["phoneNumber"] = phone;
                    return Object.assign({}, pre);
                  });
                  if (phone !== undefined) {
                    setVerifiedPhoneNumber(false);
                    if (phone.length >= 1) {
                      if (isValidPhoneNumber(phone) === false) {
                        setVerifiedPhoneNumber(false);
                        helperText.isPhoneNumber = `Please Enter valid Phone Number`;
                        setShowOtp(false);
                      } else {
                        helperText.isPhoneNumber = "verifying...";
                        if (phone?.substring(0, 3) === "+91") {
                          setIsInterNational(false);
                        } else {
                          setIsInterNational(true);
                        }
                        IsNumberBlackListed(phone);
                      }
                    }
                  } else {
                    helperText.isPhoneNumber = "Please Enter  Phone Number";
                    setShowOtp(false);
                  }
                }}
              />
              <p
                style={{ color: "red", fontSize: "1.4rem", lineHeight: "1.66" }}
              >
                {helperText.isPhoneNumber}
              </p>
              {helperText.isPhoneNumber === "" &&
                verifiedPhoneNumber === false &&
                otptimer === false &&
                showOtp === false &&
                personalDetail.phoneNumber !== "" && (
                  <div
                    className={cssClasses.verifyOtp}
                    onClick={() => {
                      smsApiCall();
                    }}
                  >
                    Verify Otp
                  </div>
                )}

              {verifiedPhoneNumber === false &&
                showOtp === true &&
                resendButton === true && (
                  <div
                    className={cssClasses.verifyOtp}
                    onClick={() => {
                      setHelperText((pre) => {
                        pre.isPhoneNumber = "";
                        return { ...pre };
                      });
                      if (resendButton) {
                        smsApiCall();
                        // successTost("Otp has been sent");
                      } else {

                        console.log("Please wait for 3 min");
                      }
                    }}
                  >
                    Resend Otp
                  </div>
                )}
              {verifiedPhoneNumber === false &&
                showOtp === true &&
                resendButton === false && (
                  <div className={cssClasses.resendOtp}>
                    {" "}
                    Resend Otp in{" "}
                    {/* <Countdown date={startDate.current+ 180000} renderer={renderer} /> */}
                    <CountdownTimer startFrom={180} onComplete={() => { setResendButton(true) }}
                      timeFormatter={(time) => {
                        return (<span>{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}</span>)
                      }}
                    />
                  </div>
                )}
              {helperText.isPhoneNumber === "" &&
                verifiedPhoneNumber &&
                otptimer === false && (
                  <div className={cssClasses.verifyOtp}>
                    <CheckCircleSharpIcon
                      style={{ fontSize: "2.5rem", marginRight: "1rem" }}
                      color={"success"}
                    />
                  </div>
                )}
              {showOtp && (
                <div className={cssClasses.otpContainer}>
                  <input
                    className={cssClasses.otpInput}
                    name="otp1"
                    type="text"
                    autoComplete="off"
                    value={state.otp1}
                    // onKeyPress={keyPressed}
                    onChange={(e) => optChange("otp1", e)}
                    tabIndex="1"
                    maxLength="1"
                    onKeyUp={(e) => inputfocus(e)}
                    id='opt-0'
                  />
                  <input
                    name="otp2"
                    type="text"
                    autoComplete="off"
                    className={cssClasses.otpInput}
                    value={state.otp2}
                    onChange={(e) => optChange("otp2", e)}
                    tabIndex="2"
                    maxLength="1"
                    onKeyUp={(e) => inputfocus(e)}
                    id='opt-1'
                  />
                  <input
                    name="otp3"
                    type="text"
                    autoComplete="off"
                    className={cssClasses.otpInput}
                    value={state.otp3}
                    onChange={(e) => optChange("otp3", e)}
                    tabIndex="3"
                    maxLength="1"
                    onKeyUp={(e) => inputfocus(e)}
                    id='opt-2'
                  />
                  <input
                    name="otp4"
                    type="text"
                    autoComplete="off"
                    className={cssClasses.otpInput}
                    value={state.otp4}
                    onChange={(e) => optChange("otp4", e)}
                    tabIndex="4"
                    maxLength="1"
                    onKeyUp={(e) => inputfocus(e)}
                    id='opt-3'
                  />

                  <div>
                    <Button
                      tabIndex={5}
                      style={{
                        color: "#ffffff",
                        backgroundColor: "#155EEF",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                      }}
                      btnName={"Submit OTP"}
                      clicked={submitOtp}
                    />
                  </div>
                </div>
              )}
            </div>
            <div>
              {personalButtonNext ? (
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={validatePersonalDetails}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              ) : (
                <Button
                  style={{
                    color: "#155EEF",
                    border: "1px solid #155EEF",
                    backgroundColor: "#ffffff",
                  }}
                  clicked={validatePersonalDetails}
                  btnName={"Proceed"}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              )}
            </div>
          </div>
        )}
        {activeStep === 4 && (
          <div className={cssClasses.wrapperGeneralDetails}>
            <div className={cssClasses.detailText}>Bank Detalis</div>
            <div>
              <CustomInput
                value={bankDetails.accountNumber}
                label={"Accoun Number"}
                //  mandatory={true}
                handleChange={(newValue) => {
                  var numbers = /^[0-9]*$/;
                  if (newValue.match(numbers) || newValue === "") {
                    if (newValue.length <= 18) {
                      setBankDetails((pre) => {
                        pre.accountNumber = newValue;
                        return Object.assign({}, pre);
                      });
                      if (
                        bankDetails.ifscCode !== "" ||
                        bankDetails.ifscCode !== null
                      ) {
                        helperText.bankDetailsIsVerified = false;
                        helperText.isAccountNumber = "verifying...";
                        debouncedBankDetailsCall();
                      } else {
                        helperText.bankDetailsIsVerified = false;
                        helperText.isAccountNumber =
                          "Please Enter Valid Ifsc code";
                      }
                    }
                  }
                  if (newValue === "") {
                    helperText.isAccountNumber = "Please Enter Account Number";
                  } else {
                    helperText.isAccountNumber = "";
                  }
                }}
                placeholder="Account Number"
                inputType="label"
                isLoading={isLoadingAccount}
                helperText={helperText.isAccountNumber}
                greenTick={helperText.bankDetailsIsVerified}
              />
            </div>
            <div>
              <CustomInput
                value={bankDetails.ifscCode}
                label={"IFSC Code"}
                //  mandatory={true}
                handleChange={(newValue) => {
                  let code = "^[A-Z]{4}0[A-Z0-9]{6}$";
                  newValue = newValue.trimStart();
                  if (newValue === "") {
                    helperText.isIfscCode = "Please Enter IFSC Code";
                  } else {
                    helperText.isIfscCode = "";
                  }
                  if (newValue.length >= 0 && newValue.length <= 11) {
                    setBankDetails((pre) => {
                      pre.ifscCode = newValue;
                      return Object.assign({}, pre);
                    });
                    if (newValue.length === 11 && newValue.match(code)) {
                      helperText.isIfscCode = "verifying...";
                      checkBankDetails(bankDetails.accountNumber, newValue);
                    } else {
                      helperText.bankDetailsIsVerified = false;
                      helperText.isIfscCode = "Please Enter Valid Ifsc code";
                    }
                  }
                }}
                placeholder="IFSC Code"
                inputType="label"
                isLoading={isLoadingIfSC}
                helperText={helperText.isIfscCode}
                greenTick={helperText.bankDetailsIsVerified}
              />
            </div>
            <div style={{ textTransform: "uppercase" }}>
              <CustomInput
                value={bankDetails.holderName}
                label={"Account Holder Name"}
                //  mandatory={true}
                handleChange={(newValue) => {
                  newValue = newValue.trimStart();
                  var alphabet = /^[A-Z*\sa-z]*$/;
                  if (newValue.match(alphabet) || newValue === "") {
                    if (newValue.length <= 40) {
                      setBankDetails((pre) => {
                        pre.holderName = newValue;
                        return Object.assign({}, pre);
                      });
                    }
                  }

                  // if (newValue === "") {
                  //   helperText.isHolderName = "Please Enter Holder Name";
                  // } else {
                  //   helperText.isHolderName = "";
                  // }
                }}
                placeholder="Account Holder Name"
                inputType="label"
                helperText={helperText.isHolderName}
                disabled={true}
              />
            </div>
            <div>
              <CustomInput
                value={bankDetails.branchName}
                label={"Branch Name"}
                // mandatory={true}
                handleChange={(newValue) => {
                  newValue = newValue.trimStart();
                  newValue = newValue.toUpperCase();
                  var alphabet = /^[A-Z*\sa-z]*$/;
                  if (newValue.match(alphabet) || newValue === "") {
                    if (newValue.length <= 40) {
                      setBankDetails((pre) => {
                        pre.branchName = newValue;
                        return Object.assign({}, pre);
                      });
                    }
                  }
                  if (newValue === "") {
                    helperText.isBranchName = "Please Enter Branch Name";
                  } else {
                    helperText.isBranchName = "";
                  }
                }}
                placeholder="Branch Name"
                inputType="label"
                helperText={helperText.isBranchName}
              />
            </div>
            <div>
              {/* {bankButtonNext ? (
               <Button
                 style={{
                   color: "#ffffff",
                   backgroundColor: "#155EEF",
                   border: "1px solid #155EEF",
                 }}
                 btnName={"Skip and next"}
                 clicked={()=>{
                  // nextStep
                  handleNext();
                 }}
                 btnIcon={<RightArrow />}
                 iconPosition={"right"}
               />
             ) : ( */}
              <Button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                  border: "1px solid #155EEF",
                }}
                btnName={"Skip and next"}
                clicked={() => {
                  if (
                    bankDetails.isIfscCode !== "" &&
                    bankDetails.accountNumber !== "" &&
                    helperText.isIfscCode === "" &&
                    helperText.isAccountNumber === "" &&
                    helperText.isHolderName === ""
                  ) {
                    handleNext();
                  } else {
                    setBankDetails((pre) => {
                      pre.accountNumber = null;
                      pre.branchName = null;
                      pre.holderName = null;
                      pre.ifscCode = null;
                      return { ...pre };
                    });
                    setHelperText((pre) => {
                      pre.isHolderName = "";
                      pre.isAccountNumber = "";
                      pre.isIfscCode = "";
                      pre.isBranchName = "";
                      return { ...pre };
                    });
                    handleNext();
                  }
                  //next step
                }}
                btnIcon={<RightArrow />}
                iconPosition={"right"}
              />
              {/* )} */}
            </div>
          </div>
        )}
        {activeStep === 5 && (
          <div className={cssClasses.wrapperGeneralDetails}>
            <div className={cssClasses.detailText}>Select CPE </div>
            <div style={{ position: "relative" }}>
              <ThemeProvider theme={theme}>
                <Autocomplete
                  id="free-solo-2-demo"
                  sx={{
                    fontSize: "1.6rem !important",
                    fontFamily: "Inter-Medium !important",
                    lineHeight: "2.4rem !important",
                    borderColor: "none !important",
                    ".MuiOutlinedInput-root": {
                      background: "#F2F4F7",
                      borderRadius: "8px",
                      "&.Mui-focused": {
                        background: "#FFFFFF",
                        border: "1px solid #84CAFF !important",
                        boxShadow:
                          "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF;",
                      },
                      // "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline ":
                      //   {
                      //     borderColor: "white !important",
                      //   },
                    },
                    "& .MuiSvgIcon-root ": {
                      display: "none !important",
                    },
                  }}
                  value={CPEDetails}
                  classes={{
                    option: classes.textStyle,
                  }}
                  options={getCPENAME.map((option) => {
                    return { label: option.billingName, value: option.cpId };
                  })}
                  PaperComponent={({ children }) => (
                    <Paper
                      style={{ fontFamily: "Inter-Medium", fontSize: "1.6rem" }}
                    >
                      {children}
                    </Paper>
                  )}
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    setCPEDetails(newValue);
                  }}
                  //  inputValue={CPDetails}
                  onInputChange={(event, newInputValue) => {
                    // setCPDetails(null);
                    console.log(newInputValue);
                    getCPEDetails(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      classes={{ root: classes.customTextField }}
                      sx={{
                        fontSize: "1.6rem !important",
                        fontFamily: "Inter-Medium !important",
                        lineHeight: "2.4rem !important",
                        " .MuiFormHelperText-root ": {
                          fontSize: "1.4rem !important",
                          fontFamily: "Inter-Medium",
                          lineHeight: "2rem",
                          marginLeft: "0rem !important",
                        },
                      }}
                      placeholder="Search CPE Name *"
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                        style: { fontSize: "3rem" },
                      }}
                      onChange={(e, v) => {
                        getCPEDetails(e.target.value);
                      }}
                      helperText={helperText.CPEName}
                      error={helperText.CPEName !== ""}
                    />
                  )}
                />
              </ThemeProvider>
              {CPEDetails === null && (
                <div
                  style={{
                    width: "2rem",
                    position: "absolute",
                    top: "2rem",
                    right: "1rem",
                  }}
                >
                  <img src={SearchIcon} alt={"SearchIcon"} />
                </div>
              )}
            </div>
            <div>
              {CPEDetails ? (
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={save}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              ) : (
                <Button
                  style={{
                    color: "#155EEF",
                    backgroundColor: "#ffffff",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={() => {
                    errorTost("Please Select CPE");
                    // if(CPDetails===null){
                    //   helperText.CPEName = "Please Enter CPE Name";
                    // }else{
                    //   helperText.CPEName = "";
                    // }
                  }}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              )}
            </div>
          </div>
        )}

        {activeStep === 6 && (
          <div className={cssClasses.wrapperDetailsSubmitted}>
            <div>
              <img
                src={greenCheckedIcon}
                alt="CheckedIcon"
                className={cssClasses.greenCheckedIcon}
              ></img>
            </div>
            <div>
              <div className={cssClasses.detailText}>Details Submited</div>
            </div>
            <div>
              <div className={cssClasses.subDetailText}>
                You have submitted your details successfully. Your account will
                be verified soon.
              </div>
            </div>
            <div>
              <span className={cssClasses.subDetailText}>
                Your Id: {fosDispalyId}{" "}
              </span>
              <ContentCopyIcon
                className={cssClasses.copyIcon}
                onClick={() => {
                  copy(fosDispalyId, {
                    debug: true,
                    message: "Press #{key} to copy",
                  });
                  successTost("id is copied");
                }}
              />
              <div className={cssClasses.textCopy}>
                Please copy this id you need this while login{" "}
              </div>
              <div className={cssClasses.wrapperCirucularProgress}>
                <span style={{ marginRight: "1rem" }}>
                  Redirecting in {counting}
                </span>
                <span style={{ color: "#155EEF" }}>
                  <CircularProgress
                    variant="determinate"
                    value={progress}
                    color="inherit"
                    sx={[
                      {
                        width: "30px !important",
                        height: "30px !important",
                      },
                    ]}
                  />
                </span>
              </div>
            </div>
            <div>
              <Button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                  border: "1px solid #155EEF",
                }}
                btnName={"Goback"}
                clicked={() => {
                  navigate("/Login");
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
